import { openBlock as e, createElementBlock as t, createElementVNode as c } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ c("path", {
  fill: "#EA1A1A",
  d: "M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20Z"
}, null, -1), l = /* @__PURE__ */ c("path", {
  fill: "#F0F0F0",
  d: "M18.843 18.64c-.312-1.391-.122-2.845.566-4.35a1.041 1.041 0 1 1 .62.315c-.665 1.465-.809 2.851-.435 4.173.119-.323.405-.723.826-1.31a37.35 37.35 0 0 0 1.7-2.551c2.093-3.455-.696-6.533-.696-6.533-7.3 3.179-4.389 8.09-2.58 10.256Zm-2.72 2.813c-2.707.662-8.542 1.174-8.117-6.87 0 0 4.001-1.12 6.156 2.297.706 1.12 1.171 2 1.52 2.662.313.59.532 1.005.75 1.263-1.472-.254-2.71-1.082-3.726-2.497a1.041 1.041 0 1 0-.553.42c1.077 1.491 2.404 2.404 3.97 2.725Zm1.325-.403.012-.005-.012.005Zm6.232-.629a.882.882 0 0 0-.394-.292l-.024-.016c1.06.35 9.804 3.522 3.295 10.903 0 0-3.831-1.607-3.399-5.623.142-1.317.324-2.295.46-3.03a21.8 21.8 0 0 0 .158-.907c.58.617 1.041 1.397 1.384 2.343a1.04 1.04 0 1 0 .682-.155c-.486-1.375-1.206-2.451-2.162-3.223Zm-.275-1.616c1.018-.658 2.271-.963 3.77-.912a1.041 1.041 0 1 0 .156-.688c-1.953-.09-3.564.372-4.82 1.391-.288.012-.49.162-.691.5 0 0 5.066-9.504 11.391-1.17 0 0-2.331 3.437-6.183 2.22a37.495 37.495 0 0 1-2.88-1.05 27.582 27.582 0 0 0-.743-.291Zm-2.931 3.868c-.016-.12-.028-.185-.028-.185a1.7 1.7 0 0 1 .016.247l.012-.062Zm.104 1.787c-.49.934-1.24 1.784-2.248 2.549a1.041 1.041 0 1 1-.496-.495c1.337-.995 2.18-2.126 2.536-3.399-.2.357-.74.513-1.76.806-.718.206-1.674.48-2.916.943-3.785 1.409-3.51 5.553-3.51 5.553 7.28 1.93 8.36-3.027 8.394-5.957Z"
}, null, -1), a = [
  n,
  l
];
function s(r, m) {
  return e(), t("svg", o, [...a]);
}
const i = { render: s };
export {
  i as default,
  s as render
};
